export const blockIconsTransportationBusAlertNew = (
	<span className='material-symbols-outlined'>bus_alert</span>
);
